module.exports = __webpack_public_path__ + "asset/img/tou.eae75217.png";